import Cookies from "js-cookie";
import {Api} from "shared/api";
import {IUser} from "shared/entities/user";
import {Vue} from "vue-property-decorator";

const TOKEN_ID = "jwt";

export class AuthService {
    static Events = new Vue();

    static get user() {
        return this.self;
    }

    static async init() {
        const token = this.getToken();
        if (token) await this.setToken(token);
    }

    static async setToken(token: string) {
        Cookies.set(TOKEN_ID, token);
        if (Api._options.params.headers) Api._options.params.headers.token = token;
        const user = await this.fetchSelf();
        this.Events.$emit("auth-change", user);
    }

    static getToken(): string | null {
        return Cookies.get(TOKEN_ID) ?? null;
    }

    static clear(): void {
        this.self = null;
        Cookies.remove(TOKEN_ID);
        if (Api._options.params.headers && Api._options.params.headers.token) delete Api._options.params.headers.token;
        this.Events.$emit("auth-change", null);
    }

    private static self: IUser|null = null;

    private static async fetchSelf(): Promise<IUser | null> {
        if (this.self) return this.self;
        try {
            const user = await Api.auth.Get();
            this.self = user;
            return user;
        } catch (e) {
            // console.error(e);
            return null;
        }
    }
}
